import i18n from '@/i18n/i18n.js'

const { t } = i18n.global

export const FARMER_DOCUMENT_TYPE = {
  KYC: 1,
  IDENTITY_CARD: 2,
  NEW_ID_CARD: 3,
  OLD_ID_CARD: 4,
  RESIDENCE_CERTIFICATE: 5,
  FARMER_REGISTRY_CERTIFICATE: 6,
  ANIMAL_REGISTRY_CERTIFICATE: 7,
  LARGE_RUMINANTS: 8,
  SMALL_RUMINANTS: 9,
  EXECUTION_PROCEEDINGS: 10,
  RISK_CENTER_REPORT: 11,
  TRACTOR_REGISTRATION: 12,
  LAND_REGISTRY: 13,
  COOPERATIVE_MEMBERSHIP: 14,
  CHAMBER_OF_AGRICULTURE_MEMBERSHIP: 15,
  PRODUCER_RECEIPT: 16,
  OTHER: 17,
  DRIVER_LICENSE: 18,
  SGK_RECORD: 19,
  RESIDENCE_HISTORY_CERTIFICATE: 20,
  CRIMINAL_RECORD: 21,
  VEHICLE_REGISTRY: 22,
  LAWSUITS: 23,
  TAX_CERTIFICATE: 24,
  PENSION_DOCUMENT: 25,
  BANK_STATEMENT: 26,
  FARMER_ACTIVITY_DOCUMENT: 27,
  BUSINESS_REGISTRATION_CERTIFICATE: 28,
  LARGE_RUMINANT_ANIMAL_HUSBANDRY_REPORT: 29,
  SMALL_RUMINANT_ANIMAL_HUSBANDRY_REPORT: 30,
  SPOUSE_CONSENT: 31
}

export const DOCUMENT_TYPE_GROUPS = {
  ID_CARDS: [FARMER_DOCUMENT_TYPE.NEW_ID_CARD, FARMER_DOCUMENT_TYPE.OLD_ID_CARD, FARMER_DOCUMENT_TYPE.DRIVER_LICENSE],
  REGISTRY_CERTIFICATES: [
    FARMER_DOCUMENT_TYPE.FARMER_REGISTRY_CERTIFICATE,
    FARMER_DOCUMENT_TYPE.ANIMAL_REGISTRY_CERTIFICATE,
    FARMER_DOCUMENT_TYPE.BUSINESS_REGISTRATION_CERTIFICATE
  ],
  INDIVIDUAL_DOCUMENTS: [
    FARMER_DOCUMENT_TYPE.RESIDENCE_CERTIFICATE,
    FARMER_DOCUMENT_TYPE.LARGE_RUMINANTS,
    FARMER_DOCUMENT_TYPE.SMALL_RUMINANTS,
    FARMER_DOCUMENT_TYPE.LARGE_RUMINANT_ANIMAL_HUSBANDRY_REPORT,
    FARMER_DOCUMENT_TYPE.SMALL_RUMINANT_ANIMAL_HUSBANDRY_REPORT
  ],
  APPLICATION_DOCUMENTS: [
    FARMER_DOCUMENT_TYPE.EXECUTION_PROCEEDINGS,
    FARMER_DOCUMENT_TYPE.RISK_CENTER_REPORT,
    FARMER_DOCUMENT_TYPE.SGK_RECORD,
    FARMER_DOCUMENT_TYPE.RESIDENCE_HISTORY_CERTIFICATE,
    FARMER_DOCUMENT_TYPE.CRIMINAL_RECORD,
    FARMER_DOCUMENT_TYPE.VEHICLE_REGISTRY,
    FARMER_DOCUMENT_TYPE.LAWSUITS,
    FARMER_DOCUMENT_TYPE.TAX_CERTIFICATE,
    FARMER_DOCUMENT_TYPE.PENSION_DOCUMENT,
    FARMER_DOCUMENT_TYPE.BANK_STATEMENT,
    FARMER_DOCUMENT_TYPE.LAND_REGISTRY,
    FARMER_DOCUMENT_TYPE.SPOUSE_CONSENT
  ]
}

export const FARMER_DOCUMENT_TYPE_MAP = {
  [FARMER_DOCUMENT_TYPE.KYC]: t('constants.farmer_document_type.kyc'),
  [FARMER_DOCUMENT_TYPE.IDENTITY_CARD]: t('constants.farmer_document_type.identity_card'),
  [FARMER_DOCUMENT_TYPE.NEW_ID_CARD]: t('constants.farmer_document_type.new_id_card'),
  [FARMER_DOCUMENT_TYPE.OLD_ID_CARD]: t('constants.farmer_document_type.old_id_card'),
  [FARMER_DOCUMENT_TYPE.DRIVER_LICENSE]: t('constants.farmer_document_type.driver_license'),
  [FARMER_DOCUMENT_TYPE.RESIDENCE_CERTIFICATE]: t('constants.farmer_document_type.residence_certificate'),
  [FARMER_DOCUMENT_TYPE.FARMER_REGISTRY_CERTIFICATE]: t('constants.farmer_document_type.farmer_registry_certificate'),
  [FARMER_DOCUMENT_TYPE.ANIMAL_REGISTRY_CERTIFICATE]: t('constants.farmer_document_type.animal_registry_certificate'),
  [FARMER_DOCUMENT_TYPE.LARGE_RUMINANTS]: t('constants.farmer_document_type.large_ruminants'),
  [FARMER_DOCUMENT_TYPE.SMALL_RUMINANTS]: t('constants.farmer_document_type.small_ruminants'),
  [FARMER_DOCUMENT_TYPE.RISK_CENTER_REPORT]: t('constants.farmer_document_type.risk_center_report'),
  [FARMER_DOCUMENT_TYPE.EXECUTION_PROCEEDINGS]: t('constants.farmer_document_type.execution_proceedings'),
  [FARMER_DOCUMENT_TYPE.TRACTOR_REGISTRATION]: t('constants.farmer_document_type.tractor_registration'),
  [FARMER_DOCUMENT_TYPE.LAND_REGISTRY]: t('constants.farmer_document_type.land_registry'),
  [FARMER_DOCUMENT_TYPE.COOPERATIVE_MEMBERSHIP]: t('constants.farmer_document_type.cooperative_membership'),
  [FARMER_DOCUMENT_TYPE.CHAMBER_OF_AGRICULTURE_MEMBERSHIP]: t(
    'constants.farmer_document_type.chamber_of_agriculture_membership'
  ),
  [FARMER_DOCUMENT_TYPE.PRODUCER_RECEIPT]: t('constants.farmer_document_type.producer_receipt'),
  [FARMER_DOCUMENT_TYPE.OTHER]: t('constants.farmer_document_type.other'),
  [FARMER_DOCUMENT_TYPE.SGK_RECORD]: t('constants.farmer_document_type.sgk_record'),
  [FARMER_DOCUMENT_TYPE.RESIDENCE_HISTORY_CERTIFICATE]: t(
    'constants.farmer_document_type.residence_history_certificate'
  ),
  [FARMER_DOCUMENT_TYPE.CRIMINAL_RECORD]: t('constants.farmer_document_type.criminal_record'),
  [FARMER_DOCUMENT_TYPE.VEHICLE_REGISTRY]: t('constants.farmer_document_type.vehicle_registry'),
  [FARMER_DOCUMENT_TYPE.LAWSUITS]: t('constants.farmer_document_type.lawsuits'),
  [FARMER_DOCUMENT_TYPE.TAX_CERTIFICATE]: t('constants.farmer_document_type.tax_certificate'),
  [FARMER_DOCUMENT_TYPE.PENSION_DOCUMENT]: t('constants.farmer_document_type.pension_document'),
  [FARMER_DOCUMENT_TYPE.BANK_STATEMENT]: t('constants.farmer_document_type.bank_statement'),
  [FARMER_DOCUMENT_TYPE.FARMER_ACTIVITY_DOCUMENT]: t('constants.farmer_document_type.farmer_activity_document'),
  [FARMER_DOCUMENT_TYPE.BUSINESS_REGISTRATION_CERTIFICATE]: t(
    'constants.farmer_document_type.business_registration_certificate'
  ),
  [FARMER_DOCUMENT_TYPE.LARGE_RUMINANT_ANIMAL_HUSBANDRY_REPORT]: t(
    'constants.farmer_document_type.large_ruminant_animal_husbandry_report'
  ),
  [FARMER_DOCUMENT_TYPE.SMALL_RUMINANT_ANIMAL_HUSBANDRY_REPORT]: t(
    'constants.farmer_document_type.small_ruminant_animal_husbandry_report'
  ),
  [FARMER_DOCUMENT_TYPE.SPOUSE_CONSENT]: t('constants.farmer_document_type.spouse_consent')
}

export const FARMER_DOCUMENT_TYPE_DISPLAY_MAP = {
  [FARMER_DOCUMENT_TYPE.KYC]: t('constants.farmer_document_type.display.kyc'),
  [FARMER_DOCUMENT_TYPE.IDENTITY_CARD]: t('constants.farmer_document_type.display.identity_card'),
  [FARMER_DOCUMENT_TYPE.NEW_ID_CARD]: t('constants.farmer_document_type.display.new_id_card'),
  [FARMER_DOCUMENT_TYPE.OLD_ID_CARD]: t('constants.farmer_document_type.display.old_id_card'),
  [FARMER_DOCUMENT_TYPE.DRIVER_LICENSE]: t('constants.farmer_document_type.display.driver_license'),
  [FARMER_DOCUMENT_TYPE.RESIDENCE_CERTIFICATE]: t('constants.farmer_document_type.display.residence_certificate'),
  [FARMER_DOCUMENT_TYPE.FARMER_REGISTRY_CERTIFICATE]: t(
    'constants.farmer_document_type.display.farmer_registry_certificate'
  ),
  [FARMER_DOCUMENT_TYPE.ANIMAL_REGISTRY_CERTIFICATE]: t(
    'constants.farmer_document_type.display.animal_registry_certificate'
  ),
  [FARMER_DOCUMENT_TYPE.LARGE_RUMINANTS]: t('constants.farmer_document_type.display.large_ruminants'),
  [FARMER_DOCUMENT_TYPE.SMALL_RUMINANTS]: t('constants.farmer_document_type.display.small_ruminants'),
  [FARMER_DOCUMENT_TYPE.RISK_CENTER_REPORT]: t('constants.farmer_document_type.display.risk_center_report'),
  [FARMER_DOCUMENT_TYPE.EXECUTION_PROCEEDINGS]: t('constants.farmer_document_type.display.execution_proceedings'),
  [FARMER_DOCUMENT_TYPE.TRACTOR_REGISTRATION]: t('constants.farmer_document_type.display.tractor_registration'),
  [FARMER_DOCUMENT_TYPE.LAND_REGISTRY]: t('constants.farmer_document_type.display.land_registry'),
  [FARMER_DOCUMENT_TYPE.COOPERATIVE_MEMBERSHIP]: t('constants.farmer_document_type.display.cooperative_membership'),
  [FARMER_DOCUMENT_TYPE.CHAMBER_OF_AGRICULTURE_MEMBERSHIP]: t(
    'constants.farmer_document_type.display.chamber_of_agriculture_membership'
  ),
  [FARMER_DOCUMENT_TYPE.PRODUCER_RECEIPT]: t('constants.farmer_document_type.display.producer_receipt'),
  [FARMER_DOCUMENT_TYPE.OTHER]: t('constants.farmer_document_type.display.other'),
  [FARMER_DOCUMENT_TYPE.SGK_RECORD]: t('constants.farmer_document_type.display.sgk_record'),
  [FARMER_DOCUMENT_TYPE.RESIDENCE_HISTORY_CERTIFICATE]: t(
    'constants.farmer_document_type.display.residence_history_certificate'
  ),
  [FARMER_DOCUMENT_TYPE.CRIMINAL_RECORD]: t('constants.farmer_document_type.display.criminal_record'),
  [FARMER_DOCUMENT_TYPE.VEHICLE_REGISTRY]: t('constants.farmer_document_type.display.vehicle_registry'),
  [FARMER_DOCUMENT_TYPE.LAWSUITS]: t('constants.farmer_document_type.display.lawsuits'),
  [FARMER_DOCUMENT_TYPE.TAX_CERTIFICATE]: t('constants.farmer_document_type.display.tax_certificate'),
  [FARMER_DOCUMENT_TYPE.PENSION_DOCUMENT]: t('constants.farmer_document_type.display.pension_document'),
  [FARMER_DOCUMENT_TYPE.BANK_STATEMENT]: t('constants.farmer_document_type.display.bank_statement'),
  [FARMER_DOCUMENT_TYPE.FARMER_ACTIVITY_DOCUMENT]: t('constants.farmer_document_type.display.farmer_activity_document'),
  [FARMER_DOCUMENT_TYPE.BUSINESS_REGISTRATION_CERTIFICATE]: t(
    'constants.farmer_document_type.display.business_registration_certificate'
  ),
  [FARMER_DOCUMENT_TYPE.LARGE_RUMINANT_ANIMAL_HUSBANDRY_REPORT]: t(
    'constants.farmer_document_type.display.large_ruminant_animal_husbandry_report'
  ),
  [FARMER_DOCUMENT_TYPE.SMALL_RUMINANT_ANIMAL_HUSBANDRY_REPORT]: t(
    'constants.farmer_document_type.display.small_ruminant_animal_husbandry_report'
  ),
  [FARMER_DOCUMENT_TYPE.SPOUSE_CONSENT]: t('constants.farmer_document_type.display.spouse_consent')
}

export const FARMER_DOCUMENT_TYPE_DATA = [
  { id: FARMER_DOCUMENT_TYPE.KYC, name: t('constants.farmer_document_type.kyc') },
  { id: FARMER_DOCUMENT_TYPE.IDENTITY_CARD, name: t('constants.farmer_document_type.identity_card') },
  { id: FARMER_DOCUMENT_TYPE.NEW_ID_CARD, name: t('constants.farmer_document_type.new_id_card') },
  { id: FARMER_DOCUMENT_TYPE.OLD_ID_CARD, name: t('constants.farmer_document_type.old_id_card') },
  { id: FARMER_DOCUMENT_TYPE.DRIVER_LICENSE, name: t('constants.farmer_document_type.driver_license') },
  { id: FARMER_DOCUMENT_TYPE.RESIDENCE_CERTIFICATE, name: t('constants.farmer_document_type.residence_certificate') },
  {
    id: FARMER_DOCUMENT_TYPE.FARMER_REGISTRY_CERTIFICATE,
    name: t('constants.farmer_document_type.farmer_registry_certificate')
  },
  {
    id: FARMER_DOCUMENT_TYPE.ANIMAL_REGISTRY_CERTIFICATE,
    name: t('constants.farmer_document_type.animal_registry_certificate')
  },
  { id: FARMER_DOCUMENT_TYPE.LARGE_RUMINANTS, name: t('constants.farmer_document_type.large_ruminants') },
  { id: FARMER_DOCUMENT_TYPE.SMALL_RUMINANTS, name: t('constants.farmer_document_type.small_ruminants') },
  { id: FARMER_DOCUMENT_TYPE.RISK_CENTER_REPORT, name: t('constants.farmer_document_type.risk_center_report') },
  { id: FARMER_DOCUMENT_TYPE.EXECUTION_PROCEEDINGS, name: t('constants.farmer_document_type.execution_proceedings') },
  { id: FARMER_DOCUMENT_TYPE.TRACTOR_REGISTRATION, name: t('constants.farmer_document_type.tractor_registration') },
  { id: FARMER_DOCUMENT_TYPE.LAND_REGISTRY, name: t('constants.farmer_document_type.land_registry') },
  { id: FARMER_DOCUMENT_TYPE.COOPERATIVE_MEMBERSHIP, name: t('constants.farmer_document_type.cooperative_membership') },
  {
    id: FARMER_DOCUMENT_TYPE.CHAMBER_OF_AGRICULTURE_MEMBERSHIP,
    name: t('constants.farmer_document_type.chamber_of_agriculture_membership')
  },
  { id: FARMER_DOCUMENT_TYPE.PRODUCER_RECEIPT, name: t('constants.farmer_document_type.producer_receipt') },
  { id: FARMER_DOCUMENT_TYPE.OTHER, name: t('constants.farmer_document_type.other') },
  { id: FARMER_DOCUMENT_TYPE.SGK_RECORD, name: t('constants.farmer_document_type.sgk_record') },
  {
    id: FARMER_DOCUMENT_TYPE.RESIDENCE_HISTORY_CERTIFICATE,
    name: t('constants.farmer_document_type.residence_history_certificate')
  },
  { id: FARMER_DOCUMENT_TYPE.CRIMINAL_RECORD, name: t('constants.farmer_document_type.criminal_record') },
  { id: FARMER_DOCUMENT_TYPE.VEHICLE_REGISTRY, name: t('constants.farmer_document_type.vehicle_registry') },
  { id: FARMER_DOCUMENT_TYPE.LAWSUITS, name: t('constants.farmer_document_type.lawsuits') },
  { id: FARMER_DOCUMENT_TYPE.TAX_CERTIFICATE, name: t('constants.farmer_document_type.tax_certificate') },
  { id: FARMER_DOCUMENT_TYPE.PENSION_DOCUMENT, name: t('constants.farmer_document_type.pension_document') },
  { id: FARMER_DOCUMENT_TYPE.BANK_STATEMENT, name: t('constants.farmer_document_type.bank_statement') },
  {
    id: FARMER_DOCUMENT_TYPE.FARMER_ACTIVITY_DOCUMENT,
    name: t('constants.farmer_document_type.farmer_activity_document')
  },
  {
    id: FARMER_DOCUMENT_TYPE.BUSINESS_REGISTRATION_CERTIFICATE,
    name: t('constants.farmer_document_type.business_registration_certificate')
  },
  {
    id: FARMER_DOCUMENT_TYPE.LARGE_RUMINANT_ANIMAL_HUSBANDRY_REPORT,
    name: t('constants.farmer_document_type.large_ruminant_animal_husbandry_report')
  },
  {
    id: FARMER_DOCUMENT_TYPE.SMALL_RUMINANT_ANIMAL_HUSBANDRY_REPORT,
    name: t('constants.farmer_document_type.small_ruminant_animal_husbandry_report')
  },
  { id: FARMER_DOCUMENT_TYPE.SPOUSE_CONSENT, name: t('constants.farmer_document_type.spouse_consent') }
]

export const FARMER_DOCUMENT_TYPE_OPTIONS = [
  { id: FARMER_DOCUMENT_TYPE.NEW_ID_CARD, text: t('constants.farmer_document_type.official_identity') },
  { id: FARMER_DOCUMENT_TYPE.RESIDENCE_CERTIFICATE, text: t('constants.farmer_document_type.residence_certificate') },
  {
    id: FARMER_DOCUMENT_TYPE.FARMER_REGISTRY_CERTIFICATE,
    text: t('constants.farmer_document_type.farmer_registry_certificate')
  },
  {
    id: FARMER_DOCUMENT_TYPE.ANIMAL_REGISTRY_CERTIFICATE,
    text: t('constants.farmer_document_type.animal_registry_certificate')
  },
  {
    id: FARMER_DOCUMENT_TYPE.BUSINESS_REGISTRATION_CERTIFICATE,
    text: t('constants.farmer_document_type.business_registration_certificate')
  },
  { id: FARMER_DOCUMENT_TYPE.LARGE_RUMINANTS, text: t('constants.farmer_document_type.large_ruminants') },
  { id: FARMER_DOCUMENT_TYPE.SMALL_RUMINANTS, text: t('constants.farmer_document_type.small_ruminants') },
  { id: FARMER_DOCUMENT_TYPE.RISK_CENTER_REPORT, text: t('constants.farmer_document_type.risk_center_report') },
  { id: FARMER_DOCUMENT_TYPE.EXECUTION_PROCEEDINGS, text: t('constants.farmer_document_type.execution_proceedings') }
]
